import { render, staticRenderFns } from "./ApprovalsFilter.vue?vue&type=template&id=bf84d8a0&scoped=true"
import script from "./ApprovalsFilter.vue?vue&type=script&lang=ts"
export * from "./ApprovalsFilter.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalsFilter.vue?vue&type=style&index=0&id=bf84d8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf84d8a0",
  null
  
)

export default component.exports